__webpack_require__.p = "https://magicmillions.digital/auction-app/";